import type { Template } from '../../types';

export const templateSource = (t: Template) =>
  t.sourceMode === 'latest_tag' ? `последний тег ${t.sourceRef}` : `ветка ${t.sourceRef}`;
